import React, { useState } from 'react';
import CarouselComponent from './CarouselComponent';
import SectionComponent from './SectionComponent';

function Landing() {
    // const [message, setMessage] = useState("Welcome to the Landing Page!");
    //
    // const handleClick = () => {
    //     setMessage("You clicked the button!");
    // };

    return (
        <div style={styles.container}>
            <CarouselComponent/>
            {/*<h1 style={styles.header}>{message}</h1>*/}
            {/*<button style={styles.button} onClick={handleClick}>*/}
            {/*    Click Me*/}
            {/*</button>*/}
            <SectionComponent/>
        </div>
);
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        // height: '100vh',
        // backgroundColor: '#f5f5f5',
    },
    header: {
        color: '#333',
        marginBottom: '20px',
    },
    button: {
        padding: '10px 20px',
        fontSize: '16px',
        cursor: 'pointer',
        backgroundColor: '#007bff',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
    }
};

export default Landing;
